import axios from 'axios';

export interface CheckEmailModelResponse {
  exists: boolean;
  restricted: boolean;
  valid: boolean;
}

export async function checkEmail(email: string): Promise<CheckEmailModelResponse> {
  const response = await axios.post(`/api/v1/check-email`, { email });
  return response.data;
}
